import PropTypes from 'prop-types';

var propTypes = {
    startDate: PropTypes.object.isRequired,
    endDate: PropTypes.object.isRequired,
    selectedRangeText: PropTypes.string,
    dateFormat: PropTypes.string,
    dateSeparator: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onStartDateButtonClick: PropTypes.func.isRequired,
    onEndDateButtonClick: PropTypes.func.isRequired,
    onMobileRowButtonClick: PropTypes.func,
    onNextIntervalClick: PropTypes.func,
    onPrevIntervalClick: PropTypes.func,
    disableNextIntervalButton: PropTypes.bool,
    disablePrevIntervalButton: PropTypes.bool,
    disabled: PropTypes.bool,
    hideIntervalShortcuts: PropTypes.bool,
    desktopClassName: PropTypes.string,
    mobileClassName: PropTypes.string,
    mobileControllerTitle: PropTypes.string,
    rowButtonProps: PropTypes.object,
};
var defaultProps = {
    dateSeparator: 'to',
    dateFormat: 'MM/DD/YYYY',
    startDate: null,
    endDate: null,
    hideIntervalShortcuts: false,
    disable: false,
    disableNextIntervalButton: false,
    disablePrevIntervalButton: false,
    mobileControllerTitle: 'Date Range',
    rowButtonProps: {},
};

export { defaultProps, propTypes };
